Handlebars.registerHelper("filter_area", function(conditional, options) {
    console.log(conditional, this);
    if(conditional){
      var area = conditional;
      var variants = this.variants;
      variants = variants.map(function(variant){
        return variant.title;
      });
      conditional = false;
      console.log(variants);
      variants.forEach(function(variant){
        if(variant === area){
          conditional = true;
          return;
        }
      });
    }
    else{
      conditional = true;
    }
    if (conditional) {
        return options.fn(this);
    } /*else {
        return options.inverse(this);
    }*/
});